export default __webpack_public_path__ + "static/media/logo-Growyx.8e87f100.svg";